"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    initialCaps: function() {
        return initialCaps;
    },
    trimString: function() {
        return trimString;
    }
});
function initialCaps(text) {
    if (!text) {
        return '';
    }
    return text[0].toUpperCase() + text.slice(1);
}
const trimString = (text)=>{
    if (!text) {
        return text;
    }
    return text.trim();
};

//# sourceMappingURL=strings.js.map